import React from 'react';
import Fidelity from '../../../../../common/components/Fidelity';

export default text => <Fidelity percentage={Number(text) * 100} absolute={text} />;
